module.exports = __webpack_public_path__ + "6ec3ee446a476872c8f5ed4da1bf6daa.png";